import { useField } from "remix-validated-form";
import { AppConfig } from "~/AppConfig";
import { Select } from '~/components/shared'
import type { SelectProps } from '~/components/shared/Select'

type SelectInput_v2_Props<T> = SelectProps<T>

function SelectInput_v2<T>(props: SelectInput_v2_Props<T>) {
  const { name, defaultValue, ...restProps } = props

  const { error, getInputProps } = useField(name || '', {
    validationBehavior: { ...AppConfig.InputValidationBehavior, initial: 'onBlur' }
  })

  // @ts-ignore
  return <Select
    defaultValue={defaultValue}
    {...getInputProps({
      ...restProps,
      // @ts-ignore
      error: Boolean(error),
      helperText: error || '',
    })}
  />
}
SelectInput_v2.Item = Select.Item

export default SelectInput_v2
